// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-content .ant-card .ant-card-head {
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 20px;
  min-height: auto;
}
.details-content .ant-card .ant-card-head-title {
  padding: 0;
}
.details-content .ant-card .ant-card-body {
  padding: 24px 20px;
}
.details-content .ant-divider {
  border-top: 1px solid #e2e8f0;
  margin: 28px 0 20px 0;
}
.details-content .ant-divider-inner-text {
  padding: 0 16px 0 0;
}
.details-content .detail-row {
  margin-bottom: 2px;
}
.details-content .detail-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 6px;
  line-height: 1.4;
}
.details-content .detail-value {
  color: #0f172a;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
}
.details-content .amount-requested {
  color: #004195;
  font-size: 16px;
  font-weight: 700;
}
.details-content .amount-approved {
  color: #15803d;
  font-size: 16px;
  font-weight: 700;
}
.details-content .refund-amount {
  color: #1d4ed8;
  font-size: 16px;
  font-weight: 700;
}
.details-content .refund-purchase-summary {
  padding: 16px;
  border: 1px solid rgba(0, 48, 135, 0.1);
  border-radius: 8px;
  background: rgba(0, 48, 135, 0.03);
}
.details-content .refund-purchase-summary__title {
  margin-bottom: 12px;
  color: #004195;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.details-content .refund-purchase-summary__rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.details-content .refund-purchase-summary__divider {
  width: 100%;
  height: 1px;
  background: #e5e7eb;
}
.details-content .refund-purchase-summary__row,
.details-content .refund-purchase-summary__total {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
}
.details-content .refund-purchase-summary__label {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
}
.details-content .refund-purchase-summary__quantity {
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
}
.details-content .refund-purchase-summary__amount {
  flex-shrink: 0;
  text-align: right;
}
.details-content .refund-purchase-summary__total {
  margin-top: 6px;
  padding-top: 12px;
  border-top: 1px dashed #cbd5e1;
  color: #004195;
  font-size: 16px;
  font-weight: 800;
}
.details-content .refund-purchase-summary__empty {
  color: #1e293b;
  font-size: 15px;
  font-weight: 500;
}
.details-content .internal-only-tag {
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #f9f0ff;
  color: #531dab;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
}
.details-content .fee-type-note {
  margin-top: 4px;
  color: #b45309;
  font-size: 12px;
  font-weight: 500;
}
.details-content .amount-paid-hint {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}
.details-content .amount-error {
  margin-top: 4px;
  color: #dc2626;
  font-size: 12px;
  font-weight: 500;
}
.details-content .awaiting-step-note {
  color: #64748b;
  font-size: 14px;
}
.details-content .status-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.4;
}
.details-content .status-badge--pending {
  background: #fef3c7;
  color: #d97706;
}
.details-content .status-badge--approved {
  background: #d1fae5;
  color: #15803d;
}
.details-content .status-badge--rejected {
  background: #fee2e2;
  color: #b91c1c;
}
.details-content .status-badge--refunded {
  background: #dbeafe;
  color: #1d4ed8;
}
.details-content .status-field {
  margin-bottom: 0;
}
.details-content .status-field > div:first-child {
  color: #53657f;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.details-content .content-rounded-field {
  border-radius: 8px;
  border-color: #cbd5e1;
}
.details-content .panel-content .ant-col {
  margin-bottom: 16px;
}
.details-content .panel-content .ant-col div:first-child {
  color: #53657f;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.details-content .panel-content .ant-col div:last-child {
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.required-field {
  color: #53657f;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.required-field::after {
  content: "*";
  color: #ff4d4f;
  margin-left: 4px;
}

.confirmation-upload-box {
  min-height: 100%;
  padding: 14px;
  border: 0;
  border-radius: 8px;
  background: #f8fafc;
}
.confirmation-upload-box .confirmation-upload-label {
  margin-bottom: 6px;
  color: #53657f;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.confirmation-upload-box .ant-upload.ant-upload-drag {
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.confirmation-upload-box .ant-upload.ant-upload-drag:hover {
  border-color: #075dc5;
  background: #f8fbff;
}
.confirmation-upload-box .confirmation-upload-content {
  display: flex;
  min-height: 76px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px;
}
.confirmation-upload-box .confirmation-upload-content * {
  font-size: 9px !important;
  line-height: 12px !important;
}
.confirmation-upload-box .confirmation-upload-icon {
  color: #075dc5;
  font-size: 14px !important;
}
.confirmation-upload-box .confirmation-upload-text,
.confirmation-upload-box .confirmation-upload-file {
  max-width: 100%;
  overflow: hidden;
  color: #1e293b;
  font-size: 9px !important;
  font-weight: 500;
  line-height: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.confirmation-upload-box .confirmation-upload-hint {
  color: #64748b;
  font-size: 8px !important;
  line-height: 10px !important;
}

.ant-radio-group .ant-radio-button-wrapper {
  border-radius: 8px;
  border-color: #cbd5e1;
}
.ant-radio-group .ant-radio-button-wrapper:first-child {
  border-radius: 8px;
}
.ant-radio-group .ant-radio-button-wrapper:last-child {
  border-radius: 8px;
}

.ant-space {
  margin-top: 8px;
}

@media (max-width: 768px) {
  .details-content .ant-card-body {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RefundRequestDetails/style.scss"],"names":[],"mappings":"AAGI;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,kBAAA;AAJN;AASE;EACE,6BAAA;EACA,qBAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AAYE;EACE,kBAAA;AAVJ;AAcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAZJ;AAgBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAdJ;AAkBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAhBJ;AAoBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAlBJ;AAsBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AApBJ;AAwBE;EACE,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,kCAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AAzBJ;AA4BE;;EAEE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,cAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;AAmCE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;AAjCJ;AAqCE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnCJ;AAuCE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AArCJ;AAyCE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,cAAA;EACA,eAAA;AAxCJ;AA4CE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AA1CJ;AA4CI;EACE,mBAAA;EACA,cAAA;AA1CN;AA6CI;EACE,mBAAA;EACA,cAAA;AA3CN;AA8CI;EACE,mBAAA;EACA,cAAA;AA5CN;AA+CI;EACE,mBAAA;EACA,cAAA;AA7CN;AAkDE;EACE,gBAAA;AAhDJ;AAkDI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAhDN;AAqDE;EACE,kBAAA;EACA,qBAAA;AAnDJ;AAwDI;EACE,mBAAA;AAtDN;AAwDM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAtDR;AAyDM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAvDR;;AA8DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AA3DF;AA6DE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;AA3DJ;;AAgEA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AA7DF;AA+DE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA7DJ;AAgEE;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wDACE;AA/DN;AAkEI;EACE,qBAAA;EACA,mBAAA;AAhEN;AAoEE;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAlEJ;AAoEI;EACE,yBAAA;EACA,4BAAA;AAlEN;AAsEE;EACE,cAAA;EACA,0BAAA;AApEJ;AAuEE;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AArEJ;AAwEE;EACE,cAAA;EACA,yBAAA;EACA,4BAAA;AAtEJ;;AA4EE;EACE,kBAAA;EACA,qBAAA;AAzEJ;AA2EI;EACE,kBAAA;AAzEN;AA4EI;EACE,kBAAA;AA1EN;;AAgFA;EACE,eAAA;AA7EF;;AAgFA;EAEI;IACE,aAAA;EA9EJ;AACF","sourcesContent":["// Card styling\n.details-content {\n  .ant-card {\n    .ant-card-head {\n      border-bottom: 1px solid #e5e7eb;\n      padding: 16px 20px;\n      min-height: auto;\n    }\n\n    .ant-card-head-title {\n      padding: 0;\n    }\n\n    .ant-card-body {\n      padding: 24px 20px;\n    }\n  }\n\n  // Divider / Section headings\n  .ant-divider {\n    border-top: 1px solid #e2e8f0;\n    margin: 28px 0 20px 0;\n\n    &-inner-text {\n      padding: 0 16px 0 0;\n    }\n  }\n\n  // Read-only field row\n  .detail-row {\n    margin-bottom: 2px;\n  }\n\n  // Read-only label\n  .detail-label {\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin-bottom: 6px;\n    line-height: 1.4;\n  }\n\n  // Read-only value\n  .detail-value {\n    color: #0f172a;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.5;\n    word-break: break-word;\n  }\n\n  // Amount Requested value\n  .amount-requested {\n    color: #004195;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  // Amount Approved value\n  .amount-approved {\n    color: #15803d;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  // Refund Amount value\n  .refund-amount {\n    color: #1d4ed8;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  // Add-ons use the same purchase-summary treatment as Payment Details.\n  .refund-purchase-summary {\n    padding: 16px;\n    border: 1px solid rgba(0, 48, 135, 0.1);\n    border-radius: 8px;\n    background: rgba(0, 48, 135, 0.03);\n  }\n\n  .refund-purchase-summary__title {\n    margin-bottom: 12px;\n    color: #004195;\n    font-size: 15px;\n    font-weight: 800;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n\n  .refund-purchase-summary__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .refund-purchase-summary__divider {\n    width: 100%;\n    height: 1px;\n    background: #e5e7eb;\n  }\n\n  .refund-purchase-summary__row,\n  .refund-purchase-summary__total {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    color: #1e293b;\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  .refund-purchase-summary__label {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 4px 10px;\n  }\n\n  .refund-purchase-summary__quantity {\n    color: #64748b;\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .refund-purchase-summary__amount {\n    flex-shrink: 0;\n    text-align: right;\n  }\n\n  .refund-purchase-summary__total {\n    margin-top: 6px;\n    padding-top: 12px;\n    border-top: 1px dashed #cbd5e1;\n    color: #004195;\n    font-size: 16px;\n    font-weight: 800;\n  }\n\n  .refund-purchase-summary__empty {\n    color: #1e293b;\n    font-size: 15px;\n    font-weight: 500;\n  }\n\n  // Internal-only tag (eligibility step is never shown to the applicant)\n  .internal-only-tag {\n    margin-left: 8px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background: #f9f0ff;\n    color: #531dab;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: none;\n  }\n\n  // Shown when the internal team's fee type differs from the applicant's request\n  .fee-type-note {\n    margin-top: 4px;\n    color: #b45309;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  // Amount-paid limit shown under refund amount inputs\n  .amount-paid-hint {\n    margin-top: 4px;\n    color: #64748b;\n    font-size: 12px;\n  }\n\n  // Inline error under a refund amount input (value kept as typed)\n  .amount-error {\n    margin-top: 4px;\n    color: #dc2626;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .awaiting-step-note {\n    color: #64748b;\n    font-size: 14px;\n  }\n\n  // Status badge in read-only sections\n  .status-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 5px 14px;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    line-height: 1.4;\n\n    &--pending {\n      background: #fef3c7;\n      color: #d97706;\n    }\n\n    &--approved {\n      background: #d1fae5;\n      color: #15803d;\n    }\n\n    &--rejected {\n      background: #fee2e2;\n      color: #b91c1c;\n    }\n\n    &--refunded {\n      background: #dbeafe;\n      color: #1d4ed8;\n    }\n  }\n\n  // Field styling for form elements\n  .status-field {\n    margin-bottom: 0;\n\n    > div:first-child {\n      color: #53657f;\n      font-size: 13px;\n      font-weight: 600;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n      margin-bottom: 8px;\n    }\n  }\n\n  // Content rounded field class\n  .content-rounded-field {\n    border-radius: 8px;\n    border-color: #cbd5e1;\n  }\n\n  // Panel content for display fields\n  .panel-content {\n    .ant-col {\n      margin-bottom: 16px;\n\n      div:first-child {\n        color: #53657f;\n        font-size: 13px;\n        font-weight: 500;\n        letter-spacing: 0.03em;\n        text-transform: uppercase;\n        margin-bottom: 4px;\n      }\n\n      div:last-child {\n        color: #1e293b;\n        font-size: 16px;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n// Required field indicator\n.required-field {\n  color: #53657f;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n\n  &::after {\n    content: '*';\n    color: #ff4d4f;\n    margin-left: 4px;\n  }\n}\n\n// Confirmation upload box styling\n.confirmation-upload-box {\n  min-height: 100%;\n  padding: 14px;\n  border: 0;\n  border-radius: 8px;\n  background: #f8fafc;\n\n  .confirmation-upload-label {\n    margin-bottom: 6px;\n    color: #53657f;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n\n  .ant-upload.ant-upload-drag {\n    border: 1px dashed #94a3b8;\n    border-radius: 8px;\n    background: #ffffff;\n    transition:\n      border-color 0.2s ease,\n      background 0.2s ease;\n\n    &:hover {\n      border-color: #075dc5;\n      background: #f8fbff;\n    }\n  }\n\n  .confirmation-upload-content {\n    display: flex;\n    min-height: 76px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 3px;\n    padding: 8px;\n\n    * {\n      font-size: 9px !important;\n      line-height: 12px !important;\n    }\n  }\n\n  .confirmation-upload-icon {\n    color: #075dc5;\n    font-size: 14px !important;\n  }\n\n  .confirmation-upload-text,\n  .confirmation-upload-file {\n    max-width: 100%;\n    overflow: hidden;\n    color: #1e293b;\n    font-size: 9px !important;\n    font-weight: 500;\n    line-height: 13px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .confirmation-upload-hint {\n    color: #64748b;\n    font-size: 8px !important;\n    line-height: 10px !important;\n  }\n}\n\n// Radio group styling\n.ant-radio-group {\n  .ant-radio-button-wrapper {\n    border-radius: 8px;\n    border-color: #cbd5e1;\n\n    &:first-child {\n      border-radius: 8px;\n    }\n\n    &:last-child {\n      border-radius: 8px;\n    }\n  }\n}\n\n// InvertFillButton spacing\n.ant-space {\n  margin-top: 8px;\n}\n\n@media (max-width: 768px) {\n  .details-content {\n    .ant-card-body {\n      padding: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
